import { PermissionT } from "../types";

export const developer = (permissions: PermissionT[]): boolean => {
  const p = permissions.find((permission) => permission.name === "developer");
  return !!p;
};

export default developer;
